import * as undoActions from 'owa-mail-undo';
import moveItemsService from '../../../services/moveItemsService';
export default function addMovedItemsToUndoStack(responseItems, destinationFolderId, sourceFolderId) {
    var movedItemIds = [];
    for (var _i = 0, responseItems_1 = responseItems; _i < responseItems_1.length; _i++) {
        var responseItem = responseItems_1[_i];
        if (responseItem.ResponseClass == 'Success') {
            movedItemIds.push(responseItem.Items[0].ItemId.Id);
        }
    }
    if (movedItemIds.length > 0) {
        undoActions.addActionToUndoStack(function () {
            // Reverse source folder id and destination folder id for undo
            return moveItemsService(movedItemIds, sourceFolderId, destinationFolderId);
        });
    }
    return movedItemIds.length;
}
//# sourceMappingURL=addMovedItemsToUndoStack.js.map